"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.c = void 0;
const react_1 = __importStar(require("react"));
const basic_form_input_1 = __importDefault(require("../../../client/form_components/inputs/basic_form_input"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const graphql_1 = require("../../../requests/graphql");
const dispatchers_1 = require("../../../utility/dispatchers");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const validators_1 = require("../../../services/validation/validators");
const Form_1 = require("./Form");
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
exports.c = { row: `${layout_css_1.default.flex} ${layout_css_1.default.fullWidth} ${layout_css_1.default.gutter15} ` };
const MailIn = ({ giveawayId }) => {
    const [form, setForm] = (0, react_1.useState)();
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)();
    const handleUpdate = ({ name, value }) => {
        setErrors({});
        setForm((prevState) => ({ ...prevState, [name]: value }));
    };
    const handleAdd = (0, react_1.useCallback)(() => {
        setIsSubmitting(true);
        const error = {
            first_name: (0, validators_1.isRequired)(form?.first_name),
            last_name: (0, validators_1.isRequired)(form?.last_name),
            email: (0, validators_1.isRequired)(form?.email) || (0, validators_1.isEmail)(form?.email),
        };
        setErrors(error);
        const hasErrors = Object.values(error).filter((val) => val).length > 0;
        if (hasErrors) {
            setIsSubmitting(false);
            return;
        }
        (0, graphql_1.graphMutate)({ t: 'create_giveaway_mail_in_registration' }, {
            ...form,
            giveaway_id: giveawayId,
        })
            .then(({ registration }) => {
            if (registration.id) {
                (0, dispatchers_1.summonGlobalMessenger)({
                    msg: 'Entry has been added!',
                    type: 'success',
                });
                // reset form so they can add another if need be.
                setForm({ first_name: '', last_name: '', email: '' });
            }
        })
            .catch((err) => {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: JSON.parse(err.response.text).errors[0],
                type: 'error',
            });
            (0, error_handler_1.default)('Create Mail-in Registration: ', err);
            return;
        }).finally(() => setIsSubmitting(false));
    }, [form, giveawayId]);
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("p", { className: Form_1.c.subHeader }, "Mail-in Entry"),
        react_1.default.createElement("div", { className: Form_1.c.form },
            react_1.default.createElement("div", { className: exports.c.row },
                react_1.default.createElement(basic_form_input_1.default, { classList: { root: layout_css_1.default.halfWidth }, disabled: isSubmitting, errors: errors?.first_name, label: "First Name", name: "first_name", onChange: ({ target: { value } }) => handleUpdate({ name: 'first_name', value }), placeholder: "Jenny", value: form?.first_name }),
                react_1.default.createElement(basic_form_input_1.default, { classList: { root: layout_css_1.default.halfWidth }, disabled: isSubmitting, errors: errors?.last_name, label: "Last Name", name: "last_name", onChange: ({ target: { value } }) => handleUpdate({ name: 'last_name', value }), placeholder: "Johnson", value: form?.last_name })),
            react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting, errors: errors?.email, label: "Email", name: "email", onChange: ({ target: { value } }) => handleUpdate({ name: 'email', value }), placeholder: "jj@email.com", value: form?.email }),
            react_1.default.createElement("div", { className: `${layout_css_1.default.flexJustifyEnd}` },
                react_1.default.createElement(base_1.default, { disabled: isSubmitting, onClick: handleAdd, size: "sm", type: "button" }, "Add")))));
};
exports.default = MailIn;
